import { useEffect } from "react";
import { LegalLayout, H, useCompany } from "@/components/legal/LegalLayout";
import { openCookiePrefs } from "@/lib/consent";

const ROWS = [
  ["salvilo_consent", "Tecnico (memoria locale)", "Ricorda le tue scelte sui cookie", "6 mesi"],
  ["access_token, refresh_token", "Tecnico", "Accesso all'area riservata (solo dopo il login)", "1 ora / 7 giorni"],
  ["_ga, _ga_*", "Statistico, terza parte (Google)", "Misurazione anonimizzata delle visite, solo con consenso", "fino a 2 anni"],
];

export default function CookiePolicy() {
  const s = useCompany();
  useEffect(() => {
    document.title = "Cookie policy · SALVILO";
  }, []);
  if (!s) return null;
  return (
    <LegalLayout eyebrow="Cookie" title="Cookie policy" testId="cookie-page">
      <p className="mt-8">Questa pagina spiega quali cookie e strumenti simili usa salvilo.it (homepage, card digitali e link QR). Titolare: {s.legal_name}{s.vat_number && `, P.IVA ${s.vat_number}`}, {s.contact_email}.</p>
      <H>Cookie tecnici</H>
      <p className="mt-3">Sono necessari al funzionamento del sito e non richiedono consenso. I caratteri tipografici sono serviti direttamente dai server di SALVILO, senza contattare servizi esterni.</p>
      <H>Cookie statistici di terze parti</H>
      <p className="mt-3">Con il tuo consenso usiamo Google Analytics (Google Ireland Ltd.) con indirizzo IP anonimizzato. Senza consenso questi cookie non vengono installati. Le card digitali usano solo cookie tecnici: Google Analytics vi viene attivato soltanto se hai già dato il consenso sul sito. Informativa di Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="underline">policies.google.com/privacy</a>.</p>
      <H>Elenco</H>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[520px] text-left text-[13px]" data-testid="cookie-table">
          <thead><tr className="border-b text-zinc-500"><th className="py-2 pr-3 font-normal">Nome</th><th className="py-2 pr-3 font-normal">Tipo</th><th className="py-2 pr-3 font-normal">Finalità</th><th className="py-2 font-normal">Durata</th></tr></thead>
          <tbody>{ROWS.map((r) => <tr key={r[0]} className="border-b align-top">{r.map((c, i) => <td key={i} className={`py-2 pr-3 ${i === 0 ? "font-mono-ui text-zinc-900" : ""}`}>{c}</td>)}</tr>)}</tbody>
        </table>
      </div>
      <H>Gestire il consenso</H>
      <p className="mt-3">Puoi accettare, rifiutare o modificare le tue scelte in qualsiasi momento. Chiudere il banner equivale a rifiutare i cookie non necessari. Ti richiederemo il consenso dopo 6 mesi. Puoi anche cancellare i cookie dalle impostazioni del browser.</p>
      <button onClick={openCookiePrefs} className="mt-5 rounded-full bg-black px-6 py-3 text-sm font-medium text-white hover:bg-zinc-800" data-testid="cookie-page-prefs">Modifica preferenze cookie</button>
      <p className="mt-8">Per altre informazioni consulta l'<a href="/privacy" className="underline">informativa privacy</a>.</p>
    </LegalLayout>
  );
}
